import { Location } from '@angular/common';
import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject, filter, firstValueFrom, Subject, Subscription } from 'rxjs';
import { CustomModalComponent } from 'src/app/components/custom-modal/custom-modal.component';
import { CustomTableSelectComponent } from 'src/app/components/custom-table-select/custom-table-select.component';
import { AuthenticationContants } from 'src/app/constants/authentication-constants';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { SellerModel } from 'src/app/models/archive/seller.model';
import { CityTableModalModel } from 'src/app/models/management/city-table-modal.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { SellerService } from 'src/app/services/archive/seller.service';
import { WindowService } from 'src/app/services/authentication/window.service';
import { FormControlStateService } from 'src/app/services/global-services/form-control-state.service';
import { UserAuthenticatedService } from 'src/app/services/global-services/user-authenticated.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { BranchService } from 'src/app/services/management/branch.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import { UpdateDocumentSellerComponent } from '../update-document-seller/update-document-seller.component';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';

@Component({
  selector: 'app-register-seller',
  templateUrl: './register-seller.component.html',
  styleUrls: ['./register-seller.component.scss'],
  standalone: false
})
export class RegisterSellerComponent implements OnInit {

  @ViewChild('changeDocumentModal') changeDocumentModalComponent?: CustomModalComponent | null = null;
  @ViewChild('selectCity') citySelectionModalComponent?: CustomModalComponent | null = null;
  ascendantCity: boolean = true;
  branchId: number = 0;
  city: string = '';
  cityData: PagedResponseModel<CityTableModalModel> = new PagedResponseModel<CityTableModalModel>();
  columnSortCity: string | null = null;
  componentChangeDocumentModal = UpdateDocumentSellerComponent;
  componentCitySelection = CustomTableSelectComponent;
  department: string = '';
  disabledForm: boolean = false;
  filtersCity: ColumnResponseModel[] = [];
  formSeller: FormGroup = new FormGroup({});
  headersCity: ColumnResponseModel[] = [];
  inputsForChangeDocumentModals$ = new BehaviorSubject<any>({
    sellerContract: new SellerModel()
  });
  inputsForSelectCityModal$ = new BehaviorSubject<any>({
    headers: [],
    data: [],
    filters: [],
    showCheckbox: true,
    showRecover: true
  });
  isOpened: string | undefined = undefined;
  limitCity: number = 10;
  listBranches: any[] = [];
  listTypeDocument: any[] = [];
  listUsers: any[] = [];
  nameWindow: string = 'Captura Vendedores';
  output$ = new Subject<any>();
  pageCity: number = 1;
  permissionUpdatable: boolean = false;
  projectName = ProjectName.projectName;
  severityState: string = 'success';
  subscription: Subscription;
  titleState: string = '';
  url: string = 'seller';
  sellerContract: SellerModel = new SellerModel();
  sellerId: number = 0;
  stateSeller: string = '';

  constructor(private activatedRoute: ActivatedRoute,
    private confirmDialogService: ConfirmDialogService,
    private branchService: BranchService,
    private formBuilder: FormBuilder,
    private formControlStateService: FormControlStateService,
    private headerService: HeaderService,
    private location: Location,
    private title: Title,
    private toastHandlerService: ToastHandlerService,
    private userAuthenticatedService: UserAuthenticatedService,
    private sellerService: SellerService,
    private windowService: WindowService) {
    this.validateForm(new SellerModel());
  }

  async ngOnInit() {
    this.headerService.setTitle(this.nameWindow);
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    this.activatedRoute.params.subscribe(params => {
      this.sellerId = Object.keys(params).length > 0 ? params?.id : null;
    });
    await this.getPermission();
    this.handleInitialState();
    this.subscription = this.output$.subscribe(({ type, payload }) => {
      switch (type) {
        case 'onPageChange':
          this.onPageChangeCity(payload);
          break;
        case 'onFilterChange':
          this.onFilterChangeCity(payload);
          break;
        default:
          console.warn('Tipo de evento desconocido:', type);
      }
    });
  }

  @HostListener('window:beforeunload')
  beforeUnloadHandler() {
    this.ngOnDestroy();
  }

  ngOnDestroy() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      const window = windowsOpened.findIndex(x => x === this.url);
      if (window != -1) {
        windowsOpened.splice(window, 1);
        localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      }
    }
  }

  async changeBranch(branchId: number, resetForm: boolean) {
    this.city = '';
    this.department = '';
    this.branchId = branchId;
    await this.getAllLists(true);
    if (resetForm) {
      this.sellerContract = new SellerModel();
      this.sellerContract.branchId = branchId;
      this.validateForm(this.sellerContract);
      this.location.replaceState(`/${this.url}/register`);
    }
  }

  async changeDocument(document: string) {
    if (document !== '') {
      const branchId = this.formSeller.get("branchId")?.value;
      const typeDocumentId = this.formSeller.get("typeDocumentId")?.value;
      await this.getSellerByDocument(branchId, document, typeDocumentId);
    } else {
      this.createNewRegister();
    }
  }

  async changeStateSeller() {
    const { sellerId } = this.sellerContract;
    if (!sellerId || sellerId === 0) {
      this.toastHandlerService.showToast(
        'warning',
        'Debe crear un vendedor.'
      );
      return;
    }
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast(
        'error',
        `No tiene permisos para cambiar el estado del vendedor. Comuníquese con el administrador del sistema.`
      );
      return;
    }
    try {
      const response = await firstValueFrom(this.sellerService.setActiveSeller(sellerId));
      this.sellerContract = response;
      this.validateForm(this.sellerContract);
      const successMessage = response.active
        ? 'El vendedor fue activado exitosamente.'
        : 'El vendedor fue inactivado exitosamente.';
      this.toastHandlerService.showToast('success', successMessage);
    } catch (error) {
      console.error('Error al cambiar el estado del vehículo.', error);
    }
  }

  createNewRegister() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast(
        'warning',
        `El usuario no tiene permisos para crear vendedores. Comuníquese con el administrador del sistema.`
      );
      return;
    }
    this.city = '';
    this.department = '';
    this.sellerId = 0;
    this.sellerContract = new SellerModel();
    this.sellerContract.branchId = this.branchId;
    this.validateForm(this.sellerContract);
    this.location.replaceState(`/${this.url}/register`);
  }

  async delete() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast(
        'error',
        `El usuario no tiene permisos para eliminar el vendedor. Comuníquese con el administrador del sistema.`
      );
      return;
    }
    if (!this.sellerId || this.sellerId === 0) {
      this.toastHandlerService.showToast(
        'warning',
        'Debe crear un vendedor.'
      );
      return;
    }
    if (await this.confirmDialogService.confirm('¿Realmente desea eliminar el vendedor?')) {
      try {
        await firstValueFrom(this.sellerService.deleteSeller(this.sellerContract.sellerId));
        this.createNewRegister();
        this.toastHandlerService.showToast(
          'success',
          'El vendedor fue eliminado exitosamente.'
        );
      } catch (error) {
        console.error('Error al eliminar el vendedor.', error);
      }
    }
  }

  async getAllLists(reload: boolean) {
    try {
      if (reload) {
        const users = await firstValueFrom(this.sellerService.getAllUserByBranchIdForSelectAsync(this.branchId));
        this.listUsers = users;
        return;
      }
      const [branches, typeDocuments, users] = await Promise.all([
        firstValueFrom(this.branchService.getAllBranchesForSelectAsync()),
        firstValueFrom(this.sellerService.getAllTypeDocumentsForSelectAsync()),
        firstValueFrom(this.sellerService.getAllUserByBranchIdForSelectAsync(this.branchId))
      ]);
      this.listBranches = branches;
      this.listTypeDocument = typeDocuments;
      this.listUsers = users;
    } catch (error) {
      console.error('Error al obtener las listas.', error);
    }
  }

  async getCitiesForSelection() {
    try {
      this.cityData = await firstValueFrom(
        this.sellerService.getCitiesForSelection(
          this.pageCity, this.limitCity, this.columnSortCity, this.ascendantCity, this.filtersCity
        )
      );
      this.updateInputsForSelectCityModal();
    } catch (error) {
      console.error('Error al obtener las ciudades para el modal.', error);
    }
  }

  async getCityDepartment(cityId: number) {
    try {
      const response: any = await firstValueFrom(this.sellerService.getCityDepartment(cityId));
      this.city = response.city;
      this.department = response.department;
    } catch (error) {
      this.city = '';
      this.department = '';
      console.error('Error al obtener la ciudad y el departamento.', error);
    }
  }

  async getColumnsForCitiesSelection() {
    try {
      if (this.headersCity.length === 0) {
        this.headersCity = await firstValueFrom(this.sellerService.getColumnsForCitiesSelection());
      }
    } catch (error) {
      console.error('Error al buscar las columnas para el modal de ciudades.', error);
    }
  }

  async getSellerByDocument(branchId: number, document: string, typeDocumentId: number) {
    try {
      const response = await firstValueFrom(this.sellerService.getSellerByDocumentAsync(branchId, document));
      if (response.sellerId != 0) {
        this.sellerId = response.sellerId;
        this.sellerContract = response;
      } else {
        this.sellerContract.typeDocumentId = typeDocumentId;
        this.sellerContract.document = response.document;
        this.sellerContract.digitVerification = response.digitVerification;
      }
      this.validateForm(this.sellerContract);
      this.location.replaceState(`/${this.url}/register/${this.sellerId}`);
    } catch (error) {
      console.error('Error al buscar el vendedor por documento.', error);
    }
  }

  async getSellerByName() {
    const branchId = this.formSeller.get("branchId")?.value;
    const name = this.formSeller.get("name")?.value;
    const previousName = this.sellerContract.name;
    if (name.toLowerCase() === previousName?.toLowerCase()) { return; }
    try {
      const response = await firstValueFrom(this.sellerService.getSellerByName(branchId, name));
      if (response) {
        if (!await this.confirmDialogService.confirm(
          `Ya existe un vendedor registrado con el documento ${response.document} y nombre "${response.name}". ¿Desea continuar?`
        )) {
          this.formSeller.get('name')?.patchValue(null);
        }
      }
    } catch (error) {
      console.error('Error al buscar el verdedor por nombre.', error);
    }
  }

  async getSellerById() {
    try {
      const response = await firstValueFrom(this.sellerService.getSellerById(this.sellerId));
      const branchChanged = this.branchId != response.branchId;
      if (branchChanged) {
        await this.changeBranch(response.branchId, false);
      }
      this.sellerContract = response;
      this.validateForm(this.sellerContract);
      this.location.replaceState(`/${this.url}/register/${this.sellerId}`);
    } catch (error) {
      console.error('Error al obtener el vendedor por id.', error);
    }
  }

  async getFirstBranchByUserAuthenticatedAsync() {
    try {
      const response = await firstValueFrom(
        this.userAuthenticatedService.branchObservable.pipe(
          filter(branch => !!branch && branch.branchId !== 0)
        )
      );
      this.branchId = response.branchId;
    } catch (error) {
      console.error('Error al obtener la primera sucursal del usuario autenticado.', error);
    }
  }

  async getPermission() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      this.isOpened = windowsOpened.find(x => x === this.url);
      windowsOpened.push(this.url);
      localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      if (this.isOpened) {
        this.toastHandlerService.showToast(
          'error',
          `No se permite tener dos ventanas/pestañas de ${this.nameWindow} abiertas.`
        );
      }
    } else {
      localStorage.clear();
    }
    await this.getFirstBranchByUserAuthenticatedAsync();
    await Promise.all([
      this.getAllLists(false),
      this.getPermissionProfileByUrl(),
    ]);
  }

  async getPermissionProfileByUrl() {
    try {
      this.permissionUpdatable = await firstValueFrom(this.windowService.getPermissionProfileByUrl(this.url));
    } catch (error) {
      console.error('Error al buscar los permisos del perfil.', error);
    }
  }

  async handleInitialState() {
    if (this.sellerId !== null && this.sellerId !== 0) {
      await this.getSellerById();
    } else {
      this.createNewRegister();
    }
  }

  async onFilterChangeCity(event: { filters: any }) {
    const filters = event.filters.map((value: any, index: any): any => ({ value, index }))
      .sort((a: any, b: any) => b.index - a.index).map((item: any) => item.value);
    this.filtersCity = this.removeDuplicates(filters);
    this.filtersCity.forEach((filter: any) => this.processFilter(filter));
    this.updateInputsForSelectCityModal();
  }

  async onPageChangeCity(event: { page: number; pageSize: number, sortField: string | undefined, sortOrder: number }) {
    this.pageCity = event.page;
    this.limitCity = event.pageSize;
    this.columnSortCity = event.sortField || null;
    this.ascendantCity = event.sortOrder === 1;
    this.getCitiesForSelection();
  }

  openChangeDocumentModal() {
    if (!this.sellerId || this.sellerId === 0) {
      this.toastHandlerService.showToast(
        'warning',
        'Debe crear un vendedor.'
      );
      return;
    }
    if (!this.sellerContract.active) {
      this.toastHandlerService.showToast(
        'warning',
        `El vendedor se encuentra inactivo.`
      );
      return;
    }
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast(
        'warning',
        `El usuario no tiene permisos para la edición de vendedores. Comuníquese con el administrador del sistema.`
      );
      return;
    }
    this.inputsForChangeDocumentModals$.next({ sellerContract: this.sellerContract });
    this.changeDocumentModalComponent && this.changeDocumentModalComponent.show();
  }

  async openCitySelectionModal() {
    if (!this.sellerContract.active) {
      this.toastHandlerService.showToast(
        'warning',
        `El vendedor se encuentra inactivo.`
      );
      return;
    }
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast(
        'warning',
        `El usuario no tiene permisos para la edición de vendedores. Comuníquese con el administrador del sistema.`
      );
      return;
    }
    try {
      this.filtersCity = [];
      await Promise.all([
        this.getColumnsForCitiesSelection(),
        this.getCitiesForSelection()
      ]);
      this.updateInputsForSelectCityModal();
      this.citySelectionModalComponent?.show();
    } catch (error) {
      console.error('Error al abrir el modal de selección de ciudad.', error);
    }
  }

  processFilter(filter: any): void {
    const { propertyName, valueFilter, valueAlterFilter } = filter;
    if (valueFilter === null || valueFilter === undefined || valueFilter === '' || valueFilter === 0) {
      this.filtersCity = this.filtersCity.filter(f => f.propertyName !== propertyName);
    } else {
      const existingFilter = this.filtersCity.find(f => f.propertyName === propertyName);
      if (existingFilter) {
        existingFilter.valueFilter = valueFilter;
        existingFilter.valueAlterFilter = valueAlterFilter;
      }
    }
  }

  removeDuplicates(filters: any[]): any[] {
    return filters.filter((value, index, self) =>
      index === self.findIndex((t: any) => t.propertyName === value.propertyName)
    );
  }

  reloadSeller(event: any) {
    if (event.reload) {
      this.sellerContract = event.sellerModel;
      this.validateForm(this.sellerContract);
    }
  }

  async setCityDepartment(selectedItems: any) {
    const [city] = selectedItems;
    this.city = `${city.cityCode} - ${city.cityName}`;
    this.department = `${city.departmentCode} - ${city.departmentName}`;
    this.formSeller.patchValue({
      cityId: city.id,
      departmentId: city.departmentId
    });
  }

  async send() {
    this.validateFormControls();
    if (this.formSeller.valid) {
      const modelSeller = this.formSeller.getRawValue() as SellerModel;
      if (modelSeller.alterCode == "") modelSeller.alterCode = null;
      if (modelSeller.phone == "") modelSeller.phone = null;
      if (modelSeller.alterPhone == "") modelSeller.alterPhone = null;
      if (modelSeller.email == "") modelSeller.email = null;
      if (modelSeller.address == "") modelSeller.address = null;
      if (modelSeller.userId == 0) modelSeller.userId = null;

      if (this.sellerId == 0) {
        try {
          const response = await firstValueFrom(this.sellerService.createSeller(modelSeller));
          this.sellerId = response.sellerId;
          this.sellerContract = response;
          this.validateForm(this.sellerContract);
          this.location.replaceState(`/${this.url}/register/${this.sellerId}`);
          this.toastHandlerService.showToast(
            'success',
            `El vendedor fue creado exitosamente.`
          );
        } catch (error) {
          console.error('Error al crear el vendedor.', error);
        }
      } else {
        this.sellerContract.branchId = modelSeller.branchId;
        this.sellerContract.typeDocumentId = modelSeller.typeDocumentId;
        this.sellerContract.document = modelSeller.document;
        this.sellerContract.digitVerification = modelSeller.digitVerification;
        this.sellerContract.alterCode = modelSeller.alterCode;
        this.sellerContract.name = modelSeller.name;
        this.sellerContract.position = modelSeller.position;
        this.sellerContract.active = modelSeller.active;
        this.sellerContract.swExternal = modelSeller.swExternal;
        this.sellerContract.phone = modelSeller.phone;
        this.sellerContract.alterPhone = modelSeller.alterPhone;
        this.sellerContract.email = modelSeller.email;
        this.sellerContract.address = modelSeller.address;
        this.sellerContract.departmentId = modelSeller.departmentId;
        this.sellerContract.cityId = modelSeller.cityId;
        this.sellerContract.observation = modelSeller.observation;
        this.sellerContract.userId = modelSeller.userId;
        try {
          const response = await firstValueFrom(this.sellerService.updateSeller(this.sellerContract));
          this.sellerContract = response;
          this.validateForm(this.sellerContract);
          this.toastHandlerService.showToast(
            'success',
            `El vendedor fue modificado exitosamente.`
          );
        } catch (error) {
          console.error('Error al modificar el vendedor.', error);
        }
      }
    } else {
      this.showValidationMessages();
    }
  }

  showValidationMessages(): void {
    const controlMessages: Record<string, Record<string, string>> = {
      branchId: {
        required: 'El campo Sucursal es obligatorio.'
      },
      typeDocumentId: {
        required: 'El campo Tipo de Documento es obligatorio.',
        min: 'Debe seleccionar un Tipo de Documento válido.'
      },
      document: {
        required: 'El campo Documento es obligatorio.',
        maxlength: 'El Documento no puede tener más de 15 caracteres.'
      },
      digitVerification: {
        required: 'El campo Dígito de Verificación es obligatorio.',
        min: 'El mínimo permitido es 0.',
        max: 'El máximo permitido es 9.'
      },
      alterCode: {
        maxlength: 'El Código Alterno no puede tener más de 6 caracteres.'
      },
      name: {
        required: 'El campo Nombre es obligatorio.',
        maxlength: 'El Nombre no puede tener más de 75 caracteres.'
      },
      position: {
        required: 'El campo Cargo es obligatorio.',
        maxlength: 'El Cargo no puede tener más de 75 caracteres.'
      },
      phone: {
        minlength: 'El número de Teléfono debe tener mínimo 7 caracteres.',
        maxlength: 'El número de Teléfono no puede tener más de 15 caracteres.'
      },
      alterPhone: {
        minlength: 'El número de Teléfono Alterno debe tener mínimo 7 caracteres.',
        maxlength: 'El número de Teléfono Alterno no puede tener más de 15 caracteres.'
      },
      email: {
        email: 'El Correo no es válido.',
        maxlength: 'El Email no puede tener más de 75 caracteres.'
      },
      address: {
        maxlength: 'La Dirección no puede tener más de 70 caracteres.'
      },
      departmentId: {
        required: 'Debe seleccionar un Departamento.'
      },
      cityId: {
        required: 'Debe seleccionar una Ciudad.',
        min: 'Debe seleccionar una Ciudad válida.',
      },
      observation: {
        maxlength: 'La Observación no puede tener más de 250 caracteres.'
      }
    };

    Object.keys(controlMessages).forEach(controlName => {
      const control = this.formSeller.get(controlName);
      if (control && control.invalid && control.errors) {
        const messages = controlMessages[controlName];
        Object.keys(control.errors).forEach(errorKey => {
          const message = messages[errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message);
          }
        });
      }
    });
  }

  updateInputsForSelectCityModal() {
    this.inputsForSelectCityModal$.next({
      headers: this.headersCity,
      data: this.cityData,
      filters: this.filtersCity,
      showCheckbox: true,
      showRecover: true
    });
  }

  updateFormState() {
    if (this.sellerContract.active) {
      this.disabledForm = false;
      this.titleState = 'inactivar';
      this.severityState = 'success';
      this.stateSeller = 'Activo';
      setTimeout(() => this.formSeller.enable());
    } else {
      this.disabledForm = true;
      this.titleState = 'Activar';
      this.severityState = 'danger';
      this.stateSeller = 'Inactivo';
      setTimeout(() => {
        this.formSeller.disable(),
          this.formControlStateService.setControlState(this.formSeller, ['branchId', 'document'], true)
      });
    }
    if (!this.permissionUpdatable) {
      this.disabledForm = true;
      setTimeout(() => this.formSeller.disable());
    }
    setTimeout(() => this.formSeller.controls["digitVerification"].disable());
  }

  async validateForm(seller: SellerModel) {
    this.formSeller = this.formBuilder.group({
      branchId: [seller.branchId, [Validators.required]],
      typeDocumentId: [seller.typeDocumentId, [Validators.required, Validators.min(1)]],
      document: [seller.document, [Validators.required, Validators.maxLength(15)]],
      digitVerification: [seller.digitVerification, [Validators.required, Validators.min(0), Validators.max(9)]],
      alterCode: [seller.alterCode, [Validators.maxLength(6)]],
      name: [seller.name, [Validators.required, Validators.maxLength(75)]],
      position: [seller.position, [Validators.required, Validators.maxLength(75)]],
      active: [seller.active],
      swExternal: [seller.swExternal],
      phone: [seller.phone, [Validators.minLength(7), Validators.maxLength(15)]],
      alterPhone: [seller.alterPhone, [Validators.minLength(7), Validators.maxLength(15)]],
      email: [seller.email, [Validators.maxLength(75), Validators.email]],
      address: [seller.address, [Validators.maxLength(70)]],
      departmentId: [seller.departmentId, [Validators.required]],
      cityId: [seller.cityId, [Validators.required, Validators.min(1)]],
      observation: [seller.observation, [Validators.maxLength(250)]],
      userId: [seller.userId]
    });
    this.updateFormState();
    if (seller.sellerId > 0) {
      await this.getCityDepartment(seller.cityId);
    }
  }

  validateFormControls() {
    Object.keys(this.formSeller.controls).forEach((key) => {
      const control = this.formSeller.get(key);
      if (control && control.invalid) {
        console.warn(
          `${key} es inválido`,
          control.errors,
          'value:',
          control.value
        );
      }
    });
  }
}
